/**
 * Qué secciones del menú tiene abiertas cada quien.
 *
 * ⚠ **En el navegador y no en la cuenta**, igual que el tema y la densidad: el
 * monitor de la oficina y el teléfono piden cosas distintas, y quien abre
 * «Organización» en uno no quiere abrirla en el otro.
 *
 * ⚠ **Se guarda lo ABIERTO, no lo plegado, porque el menú nace PLEGADO.** Es la
 * decisión del usuario: con catorce entradas repartidas en cinco secciones, el menú
 * entero obliga a recorrer una columna larga para llegar a lo de siempre. Guardar lo
 * abierto es lo único coherente con ese arranque — guardando lo plegado, una sección
 * nueva aparecería desplegada y contradiría el valor por omisión.
 *
 * ⚠ **La clave es distinta de la que hubo antes** (`…plegadas`), y a propósito: la
 * misma lista significaba lo contrario, y reusarla habría dejado a quien ya tenía algo
 * guardado con exactamente las secciones que había cerrado como las únicas abiertas.
 */

const CLAVE = "setieca.menu.abiertas"

export function leerAbiertas(): Set<string> {
  try {
    const crudo = localStorage.getItem(CLAVE)
    if (crudo === null) return new Set()
    const lista: unknown = JSON.parse(crudo)
    return Array.isArray(lista) ? new Set(lista.filter((x) => typeof x === "string")) : new Set()
  } catch {
    // Modo privado, almacenamiento lleno o un JSON que alguien tocó a mano: el menú
    // sale plegado, que es lo correcto sin preferencia. No rompe nada.
    return new Set()
  }
}

export function guardarAbiertas(abiertas: Set<string>): void {
  try {
    localStorage.setItem(CLAVE, JSON.stringify([...abiertas]))
  } catch {
    // No persiste, pero la sesión en curso sigue respetando lo que se abra.
  }
}

const CLAVE_COLAPSADO = "setieca.menu.colapsado"

/**
 * Si la barra lateral está colapsada a sólo iconos (10/10). Por omisión, no: quien
 * entra por primera vez ve los nombres. En el navegador, como el resto.
 */
export function leerColapsado(): boolean {
  try {
    return localStorage.getItem(CLAVE_COLAPSADO) === "1"
  } catch {
    return false
  }
}

export function guardarColapsado(colapsado: boolean): void {
  try {
    localStorage.setItem(CLAVE_COLAPSADO, colapsado ? "1" : "0")
  } catch {
    // No persiste, pero la sesión en curso la respeta.
  }
}
